import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable  } from 'rxjs';
import { TestService } from './test.service';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private testStartTime: number;
  private timeRemaining: number;
  private timer: ReturnType<typeof setInterval>;
  private isRunning: boolean = false;
  private timeRemainingSubject: BehaviorSubject<number>;
  timeRemaining$: Observable<number>;

  constructor (private testService: TestService) {}

  startTimer(): void {
    if (this.isRunning) return;
    this.isRunning = true;
    if (this.testService.testData().start_time !== undefined) {
      this.timeRemaining = this.remainingTimeAfterStart() * 60;
    } else {
      this.timeRemaining = parseInt(this.testService.testData().duration) * 60;
    }

    this.timeRemainingSubject = new BehaviorSubject<number>(this.timeRemaining);
    this.timeRemaining$ = this.timeRemainingSubject.asObservable();

    this.testStartTime = Math.floor(new Date().getTime() / 1000);
    let remainingTime = this.timeRemaining - this.expandedTime;

    this.timer = setInterval(() => {
      if (remainingTime % 5 == 0) {
        remainingTime = this.timeRemaining - this.expandedTime;
      }
      if (remainingTime > 0) {
        remainingTime--;
        this.timeRemainingSubject.next(remainingTime);
      } else {
        clearInterval(this.timer);
        this.isRunning = false;
        this.timeRemainingSubject.next(0);
        this.testService.submitTest();
      }
    }, 1000);
  }

  get expandedTime(): number {
    const expandedTime =
      Math.floor(new Date().getTime() / 1000) - this.testStartTime;
    return expandedTime;
  }

  remainingTimeAfterStart(): number {
    const testStart = new Date(this.testService.testData()?.start_time);
    const lastSync =
      this.testService.testData().last_sync_time == undefined
        ? testStart
        : new Date(this.testService.testData()?.last_sync_time);
    const diffInMs = lastSync.getTime() - testStart.getTime();
    const minutesLeft = Math.floor(diffInMs / 60000);
    return parseInt(this.testService.testData().duration) - minutesLeft;
  }

  formatTime(time: number): string {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }
}
